import { ExpandMore } from "@material-ui/icons";
import React, { useEffect, useRef } from "react";
import "./Select.scss";

type Option = { value: number | string; label: string };

type Props = {
    value?: number | string;
    onChange?: (value: number | string) => any;
    options: Option[];
};

const Select: React.FC<Props> = (props) => {
    const ref = useRef<HTMLDivElement>(null);

    const handleDrop = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        const close = ref.current?.classList.contains("show");
        document.querySelectorAll("#select").forEach(e => e.classList.remove("show"));
        if (!close)
        ref.current?.classList.add("show");
    };

    return (
        <div className="dropdown">
            <button
                onClick={handleDrop}
                className="dropbtn input"
                style={{ margin: 0, padding: 4, minWidth: 96 }}
            >
                <span style={{ pointerEvents: "none" }}>
                    {props.options.find((o) => o.value === props.value)
                        ?.label ?? "Select.."}
                </span>{" "}
                <ExpandMore style={{ pointerEvents: "none" }} />
            </button>
            <div className="dropdown-wrapper pt_0" id="select" ref={ref}>
                <div className="dropdown-content" style={{ minWidth: 104 }}>
                    <ul>
                        {props.options.map((val, idx) => (
                            <li
                                key={idx}
                                onClick={(e) => {
                                    if (!!props.onChange)
                                        props.onChange(val.value);
                                    handleDrop(e);
                                }}
                                className={
                                    props.value === val.value ? "selected" : ""
                                }
                            >
                                {val.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Select;
